<script lang="ts">
  import type { ExternalData } from '$lib/external';
  import { getExternalDataComponent } from '$lib/external/index';

  const { data }: { data: ExternalData } = $props();
  if (!data) {
    console.error(
      "Please provide a 'ExternalDataKey' property to the ExternlDataSource component.",
    );
  }

  let Component: ReturnType<typeof getExternalDataComponent> = getExternalDataComponent(
    data.dataKey,
  );

  // have to create and use the anytype because I don't know how to eslint ignore it in
  // the component part
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  type AnyType = any;
</script>

<Component data={data as AnyType} />
